import { useQuery } from "@tanstack/react-query";
import type { MaintenanceCapabilitiesDto, MaintenanceCapabilityDto } from "@bi/types";
import { api } from "../../lib/api";

/**
 * O que o usuário pode fazer no módulo. A API recusa de qualquer jeito (403);
 * a tela só usa isto para não oferecer um botão que vai falhar.
 */
export function useCapabilities() {
  const q = useQuery({
    queryKey: ["maintenance", "capabilities"],
    queryFn: () => api.get<MaintenanceCapabilitiesDto>("/maintenance/capabilities"),
    staleTime: 5 * 60_000,
  });
  const lista = q.data?.capabilities ?? [];
  return {
    loading: q.isLoading,
    can: (c: MaintenanceCapabilityDto) => lista.includes(c),
  };
}
